export const PROJECT_MOVE_ENABLED_FLAG = 'PROJECT_MOVE_ENABLED';

class FeatureFlagService {
  constructor() {
    this.booleanFlagCache = new Map();
    this.booleanFlagFetches = new Map();
  }

  getBooleanFeatureFlag(flagName, defaultValue) {
    if (this.booleanFlagCache.has(flagName)) {
      return Promise.resolve(this.booleanFlagCache.get(flagName));
    } else {
      const inFlight = this.booleanFlagFetches.get(flagName);
      if (inFlight) {
        return inFlight;
      } else {
        const fetchPromise = fetch(`/api/config/boolean/${flagName}`)
          .then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error(`Feature flag request failed: ${response.status}`);
            }
          })
          .then((json) => {
            const flagValue = json[flagName];
            if (flagValue === undefined) {
              return defaultValue;
            } else {
              return flagValue;
            }
          })
          .then((resolvedValue) => {
            this.booleanFlagCache.set(flagName, resolvedValue);
            this.booleanFlagFetches.delete(flagName);
            return resolvedValue;
          })
          .catch(() => {
            this.booleanFlagFetches.delete(flagName);
            return defaultValue;
          });
        this.booleanFlagFetches.set(flagName, fetchPromise);
        return fetchPromise;
      }
    }
  }
}

export default new FeatureFlagService();
